import { render, staticRenderFns } from "./APIMConsumersPage.vue?vue&type=template&id=2159e0b2&scoped=true&"
import script from "../../../public/js/img/Discoveryjs/AutorisationJs/APIMConsumersPage.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/AutorisationJs/APIMConsumersPage.js?vue&type=script&lang=js&"
import style0 from "./APIMConsumersPage.vue?vue&type=style&index=0&id=2159e0b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159e0b2",
  null
  
)

export default component.exports